/*En este JS colocar funciones que sean comunes para formularios asi se puden usar, tratar siempre de hacer funciones genericas 
que permitan su uso en otras partes de la web y no solo para un mismo form
*/
import {loadExtensionsStrings, triggerDropdown} from "./tech.newEnrollment";

const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

var T = {};

var phoneExtensionsLoaded = false;
const ZIP_CODE_REGEX = document.getElementById('zipCodeRegex');

$(function () {
    T = JSON.parse(document.getElementById('translations').value.replaceAll("##", "'"));
});

export function prueba(){
}

/*Esta funcion muestra o esconde un spiner en un boton o elemento pasado por parametro
 * para que se pueda mostrar hay que incluir en el elemento deseado una etiqueta
 * <span class="yyyyyy hidden-element" id="zzzzz"></span>
 * zzzzz = id que recibe la funcion 
 * yyyyyy = clase asignada al aspecto del spinner
 * Asegurarse que en la hoja de estilo del form existan las clases .disabled y .hidden-element
 * 
 * Modo de uso:
 * toggleSpinner('spinner-pay-button', ['button-label'], ['enrollment-third-step']);
*/
export function toggleSpinner(item, itemsToHidde, itemsToDisable) {
    let spinner = document.getElementById(item);
    let parent = spinner.parentElement;
    parent.classList.toggle('disabled',);
    spinner.classList.toggle('hidden-element');
    if (itemsToHidde != undefined) {
        itemsToHidde.forEach(function (item, index, array) {
            let element = document.getElementById(item);
            element.classList.toggle('hidden-element');
        });
    }
    if (itemsToDisable != undefined) {
        itemsToDisable.forEach(function (item, index, array) {
            let element = document.getElementById(item);
            element.classList.toggle('disabled');
        });
    }

}

export function validateInput(inputType, inputParentElement, maxLength, mandatory, showError = true) {
    let parentElement = document.getElementById(inputParentElement);
    let ret = true;
    let inputValue = null;
    if (inputType === "select") {
        inputValue = document.getElementById(inputParentElement).querySelector('select').value;    
    } else {
        inputValue = document.getElementById(inputParentElement).querySelector('input').value.trim();
        if (inputType != "checkbox") {
            document.getElementById(`${inputParentElement}-input`).value = inputValue;
        }
    }
    // Campo obligatorio
    if (mandatory && inputValue.trim().length === 0 && inputType !== "checkbox") {
        if (showError === true) {
            parentElement.querySelector('span.tech-error-message').innerText = T.campoObligatorio
        }
        ret = false;
        return ret;
    } else {
        
            parentElement.querySelector('span.tech-error-message').innerText = "";
        
        ret = true;
    }
    // Longitud
    if (inputType !== "date") {
        if (inputValue.trim().length > maxLength && inputType !== "checkbox") {
            if (showError === true) {
                parentElement.querySelector('span.tech-error-message').innerText = "Longitud máxima de " + maxLength;
            }
            ret = false;
            return ret;
        } else {
            parentElement.querySelector('span.tech-error-message').innerText = "";
            ret = true;
        }
    }
    // Email
    if (inputType === "email") {
        /*if (!validEmail(inputValue)) {
            if (showError === true) {
                parentElement.querySelector('span.tech-error-message').innerText = T.emailError;
            }
            ret = false;
        } else {
            parentElement.querySelector('span.tech-error-message').innerText = "";
            ret = true;
        }*/
    // Teléfono
    } else if (inputType === "phone") {
        let pattern = /^(\+\d+|\d+)$/;
        if (pattern.test(inputValue.trim())) {
            ret = true;
        } else {
            if (showError) {
                parentElement.querySelector('span.tech-error-message').innerText = T.tlfError;
            }
            ret = false;
        }
        /*if (!formatPhoneNumber(inputValue)) {
            if (showError === true) {
                parentElement.querySelector('span.tech-error-message').innerText = T.tlfError;
            }
            ret = false;
        } else {
            parentElement.querySelector('span.tech-error-message').innerText = "";
            ret = true;
        }*/
    // Checkbox
    } else if (inputType === "checkbox") {
        inputValue = document.getElementById(inputParentElement).querySelector('input').checked;
        if (inputValue === false) {
            if (showError === true) {
                parentElement.querySelector('span.tech-error-message').innerText = T.campoObligatorio;
            }
            ret = false;
        } else {
            parentElement.querySelector('span.tech-error-message').innerText = "";
            ret = true;
        }
    } else if (inputType === "date") {
        inputValue = inputValue !== "" ? new Date(inputValue) : "";
        if (inputValue > new Date()) {
            parentElement.querySelector('span.tech-error-message').innerText = T.enrolment_BirthDateError.Value;
        } else {
            parentElement.querySelector('span.tech-error-message').innerText = "";
            ret = true;
        }
    }
    if (inputValue.length > 0 && ret === true) {
        parentElement.querySelector('span.tech-error-message').innerText = "";
    }
    return ret;
}

function validEmail(email) {
    email = email.toLowerCase();
    const regex = /^[a-z0-9]+([._a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$/;
    return regex.test(email);
}

function formatPhoneNumber(phoneValue) {
    let phoneCountry = document.getElementById("tech-phone-countries-button-value").getAttribute("user-country");
    let number = phoneUtil.parseAndKeepRawInput(phoneValue, phoneCountry);
    return !!phoneUtil.isValidNumberForRegion(number, phoneCountry);
}

export function toggleSpinnerBlock(spinnerItem, parentItem, itemsToDisable, message, show) {
    let spinner = document.getElementById(spinnerItem);
    let parent = document.getElementById(parentItem);
    let spinnerMessageWrapper = document.getElementById('payment-spinner-message');

    if (show) {
        parent.classList.toggle('relative-parent', show);
        spinner.classList.toggle('hidden-element', !show);
    } else {
        spinner.classList.toggle('hidden-element', !show);
        parent.classList.toggle('relative-parent', show);
    }

    spinnerMessageWrapper.textContent = message;

    if (itemsToDisable != undefined && itemsToDisable != '') {
        itemsToDisable.forEach(function (item, index, array) {
            let element = document.getElementById(item);
            element.classList.toggle('disabled', show);
        });
    }

}
export function inputError(element) {
    const elementInput = element.querySelector('input');
    const elementLabel = element.querySelector('label')
    if (elementInput.getAttribute('type') !== 'checkbox') {
        elementInput.classList.contains('input-error') ? "" : elementInput.classList.add('input-error');
        elementLabel.classList.contains('input-error') ? "" : elementLabel.classList.add('input-error');
    }
}
export function validTextField(text) {
    const regex = /^[a-zA-ZÀ-ÿ\s]*$/;
    return regex.test(text);
}

export function toggleDropdown(dropdownElement, searchInput) {
    let dropdown = document.getElementById(dropdownElement);
    if (dropdown.classList.contains('dropdown-hidden')) {
        dropdown.classList.remove('dropdown-hidden')
        document.getElementById(searchInput).focus();
        document.addEventListener("click", function(evt) {
            triggerDropdown(evt, dropdown);
        })
    } else {
        dropdown.classList.add('dropdown-hidden');
        document.removeEventListener("click", function(evt) {
            triggerDropdown(evt);
        })
    }
    if (phoneExtensionsLoaded === false) {
        loadExtensionsStrings();
    }
}

export function filterSearch(searchInput, resultContainer, filterAttribute) {
    let searchString = document.getElementById(searchInput).value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    let contentToFilter = document.getElementById(resultContainer).children;
    Array.from(contentToFilter).forEach((e) => {
        let itemString = e.getAttribute(filterAttribute).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        if (!itemString.includes(searchString)) {
            e.classList.add('hidden-element');
        } else {
            if (e.classList.contains('hidden-element')) {
                e.classList.remove('hidden-element');
            }
        }
    })
}

export function selectUserCountry(countryCode, resultInput) {
    document.getElementById(resultInput).setAttribute('country-code', countryCode.toUpperCase());
    document.getElementById(resultInput).value = document.getElementById("country-" + countryCode).getAttribute("country-name");
    validateInput('text', 'user-data-country-dropdown', 200, true);
    toggleDropdown('user-data-country');
}

export function selectUserState(state, resultInput) {
    document.getElementById(resultInput).value = state;
    validateInput('text', 'user-data-state-dropdown', 200, true);
    toggleDropdown('user-data-state')
}

export function changeCountryResidence(countryCode) {

    const selectValue = document.getElementById('user-data-state-input')
    if (selectValue != null) {
        selectValue.value = '';
    }

    $.ajax({
        type: 'POST',
        url: tech.core.getInternationalUrl('/Course/ChangePersonalDataEnrollmentCountry'),
        data: {
            countryCode: countryCode,
        },
        success: function (response) {
            if (response.succed === true) {
                updateSelect(response.data.listRegions);
                changePostalCode(response.data.postalCodeRegex);
                updateTranslations(countryCode);
            }
        },
        error: function (jQXHR, textStatus, errorThrown) {
            console.log("An error occurred while trying to contact the server: " + jQXHR.status + " " + textStatus + " " + errorThrown);

        },
    })
}

function updateTranslations(countryCode) {
    $.ajax({
        type: 'GET',
        url: tech.core.getInternationalUrl('/Course/OnEnrollmentCountryChange'),
        data: {
            selectedCountry: countryCode
        },
        success: function (response) {
            reloadFromNation(response.translations, countryCode);
            showHideInputs(translationExists(response.translations, "ContactData.Subdivision"), response.translations);
        },
        error: function (jQXHR, textStatus, errorThrown) {
            console.log("An error occurred while trying to contact the server: " + jQXHR.status + " " + textStatus + " " + errorThrown);
        },
    })
}

function reloadFromNation(translations, countryCode) {
    let locationInput = document.getElementById("user-data-town-input");
    let locationExist = translationExists(translations, 'ContactData.Town');
    locationExist ? locationInput.classList.remove("d-none") : locationInput.classList.add("d-none");
    if (locationExist) {
        locationInput.nextElementSibling.innerText = getTranslation(translations, 'ContactData.Town', 'Localidad');
    }
    document.getElementById('user-data-state-input').nextElementSibling.innerText = getTranslation(translations, 'ContactData.State', 'Provincia');
}
function getTranslation( translations, code, defaultTranslation ) {
    return translationExists(translations, code) ? translations[code] : defaultTranslation;
}

function translationExists(translations, code) {
    return !!translations && !!translations[code];
}

function showHideInputs(show, translations) {
    let currentUrl = document.URL.split('/');
    if (currentUrl[currentUrl.length - 2] !== "bienvenida") {
        let subdivisionData = document.getElementById("user-data-subdivision");
        if (show) {
            subdivisionData.classList.contains('d-none') ? subdivisionData.classList.remove('d-none') : "";  
            document.getElementById("user-data-subdivision-label").innerText = getTranslation(translations, "ContactData.Subdivision", "Subdivisión"); 
        } else {
            subdivisionData.classList.contains('d-none') ? "" : subdivisionData.classList.add('d-none');
        }
    }
}

function updateSelect(newRegions) {
    const select = document.getElementById("state-result");
    select.innerHTML = '';   

    newRegions.forEach((e) => {
        if (e.value !== null) {
            const newElement = document.createElement("div");
            const newElementSpan = document.createElement("div");
            newElement.id = "state-" + e.value.toLowerCase();
            newElement.setAttribute("state-name", e.value);
            newElement.onclick = function(){selectUserState(e.value.toLowerCase(), 'user-data-state-input')}
            newElementSpan.id = 'tech-nationality-countries-button-value';
            newElementSpan.setAttribute('class', 'enrollment-dropdown-nationality dropdown-text');
            newElementSpan.innerText = e.value;
            newElement.appendChild(newElementSpan);
            select.appendChild(newElement);
        }
    });
}

function changePostalCode(newCode) {
    ZIP_CODE_REGEX.value = newCode
}

export function scrollToElement(element) {
    var elementRect = element.getBoundingClientRect();
    const absoluteElementTop = elementRect.top + window.pageYOffset;
    const middle = absoluteElementTop - (window.innerHeight / 2);

    window.scroll(0, middle);
}

export function cleanStrings(text, isPhoneNumber) {
    let cleanString = ""
    if (isPhoneNumber) {
        cleanString = text.trim().replace(" ", "");
    } else {
        cleanString = text.trim().replace("  ", " ");
    }
    
    return cleanString
}